import React, { useEffect, useState } from 'react';
import { Form, Input, Button, notification, Row, Col } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { claimsApi } from '../apiCalls/claimsApi';
import PageTitle from '../components/PageTitle';

const ClaimFormEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchClaim = async () => {
      setLoading(true);
      const claim: any = await claimsApi.getClaimById(id!);
      if (claim) {
        form.setFieldsValue({
          name: claim.name,
        });
      } else {
        notification.error({
          message: 'Error',
          description: 'Claim not found.',
          duration: 3,
        });
      }
      setLoading(false);
    };

    fetchClaim();
  }, [id, form]);

  const onFinish = async (values: any) => {
    const claimData = {
      ...values,
    };

    const result = await claimsApi.updateClaim(id!, claimData);
    if (result) {
      notification.success({
        message: 'Claim Updated',
        description: 'The claim has been successfully updated.',
        duration: 3,
      });
      navigate('/claims');
    } else {
      notification.error({
        message: 'Error updating',
        description: 'There was an error updating the asset.',
        duration: 3,
      });
    }
  };

  return (
      <div style={{ padding: 24 }}>
        <PageTitle title="Edit Claim" />
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Name" name="name">
                <Input placeholder="Enter the name" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save Claim
            </Button>
          </Form.Item>
        </Form>
      </div>
  );
};

export default ClaimFormEdit;
